import type { FunctionComponent, MouseEventHandler } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { OutlinedFullWidthButton } from '../../../../../design/components/button/OutlinedFullWidthButton';

type ShowAllButtonProps = {
    readonly onClick: MouseEventHandler<HTMLButtonElement>;
    readonly showAll: boolean;
};

export const ShowAllButton: FunctionComponent<ShowAllButtonProps> = (props) => {
    const { translate } = useContext(ApplicationContext);
    const showAllText = !props.showAll ? translate('common.show-all') : translate('common.show-less');

    return <OutlinedFullWidthButton label={showAllText} onClick={props.onClick} />;
};
